import React from 'react';
import CheckTile from '../CheckTile';
import classes from './section.module.scss';
import cn from 'classnames';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const Section = props => {
  const {
    section,
    showPopup,
    checkList,
    onFooterButtonPress,
    count,
    isAllEmpty,
  } = props;

  return (
    <div className={cn(classes.sectionContainer, 'col-4 pl-0 h-100')}>
      <div className={cn(classes.sectionHeader, 'fw-500')}>
        {section?.name} <span className="m-1">({count})</span>
      </div>
      <div className={cn(classes.checkTileWrapper, 'col-12 px-0 overflowY')}>
        {section.key === 'inProgress' && isAllEmpty ? (
          <div className="h-100 d-flex justify-content-center align-items-center">
            {FLABEL().CHECK_NO_CHECKS_AVAILABLE}
          </div>
        ) : (
          checkList.map(check => (
            <CheckTile
              {...props}
              key={check.id}
              section={section}
              check={check}
              showPopup={showPopup}
              onFooterButtonPress={onFooterButtonPress}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Section;
